import { GIVEAWAY_DATA, GIVEAWAY_CHECK, GIVEAWAY_JOB, GIVEAWAY_DETAIL, GIVEAWAY_DETAIL_USER, ALERT_MODAL } from './action';

const initialState = {
    giveawayData: null,
    giveawayCheck: null,
    giveawayJob: null,
    giveawayDetail: null,
    giveawayDetailUser: null,
    alert: {
        content: null,
        title: null,
        show: false,
    },
}

function giveawayReducer(state = initialState, action: { type: any; payload: any; }) {
    switch (action.type) {
        case GIVEAWAY_DATA:
            return { ...state, giveawayData: action.payload };
        case GIVEAWAY_CHECK:
            return { ...state, giveawayCheck: action.payload };
        case GIVEAWAY_JOB:
            return { ...state, giveawayJob: action.payload };
        case GIVEAWAY_DETAIL:
            return { ...state, giveawayDetail: action.payload };
        case GIVEAWAY_DETAIL_USER:
            return { ...state, giveawayDetailUser: action.payload };
        case ALERT_MODAL:
            return { ...state, alert: action.payload };
        default:
            return state;
    }
}

export default giveawayReducer;